import { CategoryPageTemplate } from './CategoryPageTemplate'

export function FaceSurgeryPage() {
  return <CategoryPageTemplate categoryKey="faceSurgery" namespace="faceSurgery" />
}
